import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import FieldsFactory from "../../../../fields-factory";
import {FieldType} from "../../../../field-type";
import FieldFormElementView from "../../../../render/form-elemnent-view";

const debug = false
// const debug = "FieldEventStatus_ConditionForm"

export default class FieldEventStatus_ConditionForm extends FieldProto_ConditionForm {

    render() {
        debug && console.log(debug, 'render', this.props)

        // const options = this.props.field.options || undefined
        const options = [
            {
                value   : true,
                label   : 'Accomplished'
            },
            {
                value   : false,
                label   : 'Not accomplished'
            }
        ]

        const field = FieldsFactory.get({
            type            : FieldType.DROPDOWN,
            fieldId         : 'value',
            options         : options,
            showMenuMore    : false,
            noValueOption   : false
        })

        if (!field) return <div>Error</div>

        return (
            <React.Fragment>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <FieldFormElementView field={field} model={{value: this.props.condition.value}} onChange={this.onChangeValue}
                                      className                        = "selector w-250 m-l-10"
                />

                {/*<SelectMultiGenericNew className                        = "selector w-250 m-l-10"*/}
                {/*                       options                          = {options}*/}
                {/*                       values                           = {this.props.condition.value}*/}
                {/*                       popoverScrollContainerClasses    = "max-h-200 max-w-200"*/}
                {/*                       valueComponent                   = {FieldEventStatus_MultiselectValueNotEmpty}*/}
                {/*                       popoverOptionComponent           = {FieldEventStatus_MultiselectPopoverOption}*/}
                {/*                       isSearchable                     = {true}*/}
                {/*                       // disabled                         = {disabled}*/}
                {/*                       onChange                         = {this.onChangeValue}/>*/}
            </React.Fragment>
        )
    }
}